import PageLayout from "@/components/site/PageLayout";
import PageHeader from "@/components/site/PageHeader";
import Contact from "@/components/site/Contact";
import SEO from "@/components/site/SEO";

export default function ContactPage() {
  return (
    <PageLayout testid="contact-page">
      <SEO
        title="Contact Sudeeksha Invisible Grills Hyderabad — Free Site Visit"
        description="Call +91 70325 07529, WhatsApp or email for a free invisible grill site visit and no-obligation quote anywhere in Hyderabad."
        path="/contact"
      />
      <PageHeader
        eyebrow="Get in touch"
        title={["Contact", "Us"]}
        crumb="Contact Us"
        subtitle="Call, WhatsApp or send us your requirement — we offer a free site visit and a no-obligation quote."
      />
      <Contact />
    </PageLayout>
  );
}
